import React, { Component } from "react"
import { Map as GoogleMap, GoogleApiWrapper, Marker } from "google-maps-react"

const googleMapsApiKey = process.env.GATSBY_GOOGLE_MAPS_API_KEY

const mapStyles = {
  width: "100%",
  height: "100%",
}

export class Map extends Component {
  render() {
    return (
      <GoogleMap
        google={this.props.google}
        zoom={15}
        style={mapStyles}
        initialCenter={{
          lat: 60.276183,
          lng: 24.846380,
        }}
      >
        <Marker onClick={this.onMarkerClick} name={"Hiusstudio Gaia"} />
      </GoogleMap>
    )
  }
}

export default GoogleApiWrapper({
  apiKey: googleMapsApiKey,
})(Map)
